import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingGate from "./components/LoadingGate";
import MainLayout from "./layout/MainLayout";
import AppProviders from "./providers/AppProviders";
import AppRoutes from "./router/AppRoutes";
import ScrollToTop from "./router/ScrollToTop";

/**
 * App - Root application component
 * Sets up routing, authentication context, and error boundaries
 */
function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <AppProviders>
          <LoadingGate>
            <MainLayout>
              <AppRoutes />
            </MainLayout>
          </LoadingGate>
        </AppProviders>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
